import type React from "react";
import { createStyles, makeStyles, type Theme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { DatePicker } from "@mui/x-date-pickers";
import { getMomentTz } from "@dexteel/mesf-core";

const moment = getMomentTz();

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiFormLabel-root": {
				transform: "translate(14px, -6px) scale(0.75) ",
				backgroundColor: "#FFFF",
				transition: "none !important",
				left: -3.5,
				padding: "0 5px",
			},
			"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
				borderColor: "#3F51B5",
			},
			"& .MuiFormLabel-root.Mui-focused": {
				color: "#3F51B5",
			},
		},
		description: {
			marginBottom: theme.spacing(2),
			color: theme.palette.text.secondary,
		},
		title: {
			marginBottom: theme.spacing(1),
			fontWeight: 500,
		},
	}),
);

interface StartDateStepProps {
	startDate: Date | null;
	onStartDateChange: (date: Date | null) => void;
}

export const StartDateStep: React.FC<StartDateStepProps> = ({
	startDate,
	onStartDateChange,
}) => {
	const classes = useStyles();

	return (
		<Grid
			container
			spacing={2}
			style={{ display: "flex", justifyContent: "center", marginBottom: 15 }}
		>
			<Grid item xs={4} className={classes.root}>
				<DatePicker
					label="First ocurrence"
					timezone={"UTC"}
					format="MM/DD/YYYY"
					value={moment(startDate) as any}
					onChange={(value) => {
						onStartDateChange(value ? value.toDate() : null);
					}}
					sx={{
						width: "100%",
						"& .MuiFormLabel-root": {
							marginTop: "5px !important",
						},
						"& .MuiButtonBase-root": {
							marginTop: "8px !important",
						},
					}}
					slotProps={{
						textField: {
							fullWidth: true,
							variant: "outlined",
							InputProps: {
								style: {
									height: "40px",
									marginTop: 8.5,
								},
							},
							inputProps: {
								style: {
									paddingTop: "16px",
								},
							},
						},
					}}
				/>
			</Grid>
		</Grid>
	);
};
